import { prop } from 'ramda'
import { useSessionState } from '@btime/react-session'

export const usePermalinkToken = () => {
  return prop('permalinkToken', useSessionState())
}

export const useIsPermalinkPage = () => {
  return !!usePermalinkToken()
}
